export function pickLocaleName(name, nameZh, language) {
    const en = name?.trim() ?? "";
    const zh = nameZh?.trim() ?? "";
    if (language.startsWith("zh"))
        return zh || en;
    return en || zh;
}
/** Text for the invitation card.
 * Matching locale first: invitation text, then party name.
 * The other locale is used only when both of those are blank, invitation text first.
 */
export function invitationCardPartyName(partyName, partyNameZh, cardName, cardNameZh, language) {
    const cardEn = cardName?.trim() ?? "";
    const cardZh = cardNameZh?.trim() ?? "";
    const partyEn = partyName?.trim() ?? "";
    const partyZh = partyNameZh?.trim() ?? "";
    const ordered = language.startsWith("zh")
        ? [cardZh, partyZh, cardEn, partyEn]
        : [cardEn, partyEn, cardZh, partyZh];
    return ordered.find((value) => value) ?? "";
}
export function pickLocalePath(path, pathZh, language) {
    const chosen = pickLocaleName(path, pathZh, language);
    return chosen || null;
}
/** Every seat is a named member, and there is more than one person to choose. */
export function isFullyNamedParty(memberCount, maxAttendees) {
    return memberCount > 1 && memberCount === maxAttendees;
}
export function needsPartyPerson(guest) {
    return (guest.effectiveMode === "party" &&
        (guest.members?.length ?? 0) > 0 &&
        !guest.selectedMember);
}
export function personalGuestName(guest, language = "en_hk") {
    if (guest.selectedMember) {
        return pickLocaleName(guest.selectedMember.name, guest.selectedMember.nameZh, language);
    }
    return pickLocaleName(guest.name, guest.nameZh, language);
}
export function personalGuestIcon(guest) {
    if (guest.selectedMember)
        return guest.selectedMember.icon ?? null;
    return guest.icon ?? null;
}
//# sourceMappingURL=guestIdentity.js.map